import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "@/redux/actions";
import SntImpersonateUserIcon from "@icons/SntImpersonateUserIcon";
import SntSupportUserIcon from "@icons/SntSupportUserIcon";
import userClient from "../../../apis/userClient";
import useUser from "@/hooks/useUser";
import SntButton from "@/cleanup/widgets/forms/SntButton";
import SntSupportAdminIcon from "@icons/SntSupportAdminIcon";
import useErrorDialog from "@/cleanup/widgets/dialog/useErrorDialog";

const ImpersonateHeader = ({ impersonateUser, onLeaveClicked }) => {
  const language = useSelector((state) => state.language);
  const loginInfo = useSelector((state) => state.user);
  const history = useHistory();

  const { onImpersonateUser, IMPERSONATE_TYPE } = useUser();

  const dispatch = useDispatch();

  const { handleOpen: openErrorDialog, ErrorDialog } = useErrorDialog({
    language,
  });

  const handleClick = (e) => {
    onLeaveClicked && onLeaveClicked();

    userClient
      .getPrevUserByTokens()
      .then(({ data }) => {
        dispatch(actions.preventSidebar(true)); //store in redux

        const bc = new BroadcastChannel("impersonate_reload");
        bc.postMessage(
          "reload the tabs."
        ); /* send reloading event, msg content doesn't matter */
        bc.close();

        history.push("/");
      })
      .catch((error) => {
        history.push("/logout");
      });
  };

  return impersonateUser && loginInfo ? (
    <div
      style={{
        zIndex: 1003,
        height: 50,
        position: "fixed",
        width: "100%",
        backgroundColor: impersonateUser.supportMode
          ? "rgb(255 168 88)"
          : "#212851",
        color: impersonateUser.supportMode ? "#212851" : "white",
      }}
      className="d-flex align-items-center ps-4"
    >
      {impersonateUser.supportMode ? (
        <>
          <div className="pe-3">
            {impersonateUser.adminMode ? (
              <SntSupportAdminIcon size={24} />
            ) : (
              <SntSupportUserIcon size={24} />
            )}
          </div>
          <div className="pe-3">
            <span className="fw-bold">{language.support_mode_key}</span>
            {" | "}
            <span>
              {impersonateUser.adminMode ? (
                <>{language.sidebar_admin_key}</>
              ) : (
                <>{language.read_only_key}</>
              )}
            </span>
            {" | "}
            <span
              title={
                !impersonateUser.hasAdminMode && !impersonateUser.adminMode
                  ? language.viewer_title_key
                  : ""
              }
              className="pe-3"
            >
              {language.organization_key}: {loginInfo.organisation.name}
            </span>
            {impersonateUser.hasAdminMode && !impersonateUser.adminMode ? (
              <SntButton
                variant="sensolus"
                className="me-3"
                style={{ backgroundColor: "#ffa85800", color: "#212851" }}
                onClick={() => {
                  onImpersonateUser({
                    id: loginInfo.organisation.id,
                    type: IMPERSONATE_TYPE.ADMIN,
                    onBadRequest: (error) => {
                      openErrorDialog(
                        language.impersonation_insufficient_rights_key
                      );
                    },
                  });
                }}
                icon={<SntSupportAdminIcon />}
                text={language.admin_mode_key}
              />
            ) : (
              <></>
            )}
            <Button
              variant="sensolus"
              style={{ backgroundColor: "#ffa85800", color: "#212851" }}
              onClick={handleClick}
            >
              {language.leave_key}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="pe-3">
            <SntImpersonateUserIcon size={24} />
          </div>
          <div className="pe-3">
            <span className="fw-bold">{language.impersonation_mode}</span> |{" "}
            <span>
              {language.user_key}: {loginInfo.fullName}
            </span>{" "}
            - <span>{loginInfo.organisation.name}</span>
          </div>
          <div className="pe-3">
            <Button
              variant="sensolus"
              style={{ borderColor: "white" }}
              className="fw-bold"
              onClick={handleClick}
            >
              {language.leave_key}
            </Button>
          </div>
        </>
      )}
      <ErrorDialog />
    </div>
  ) : (
    <></>
  );
};

export default ImpersonateHeader;
